import { render, staticRenderFns } from "./UmDbDeckList.vue?vue&type=template&id=7a7bfe81&"
import script from "./UmDbDeckList.vue?vue&type=script&lang=js&"
export * from "./UmDbDeckList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports